define('partner/marketing-overlay',[
    'jquery',
    'underscore',
    'baseview',
    'utils',
    'admanager',
    'adPosition',
    'adLogger',
    'cookie'
],
function(
    $,
    _,
    BaseView,
    Utils,
    AdManager,
    AdPosition,
    AdLogger
) {
    'use strict';
    var MarketingOverlay = BaseView.extend({

        initialize: function(options) {
            _.bindAll(this, 'onAdResponse', '_onCreativeBody', '_onExitOverlay', '_showOverlay', '_closeOverlay', '_delayExitOverlay');

            this.$slot = $('<div id="marketingSlot"></div>');
            this.$el.append(this.$slot);

            options = $.extend({
                el: this.$slot,
                adType: 'popup',
                adPlacement: 'consumer_sales-overlay',
                adSizes: [800, 530],
            }, options);
            
            BaseView.prototype.initialize.call(this, options);

            this._hijackRequest();
            this.subviews.ad = new AdPosition(options);
        },

        destroy: function(removeEl) {
            this._removeEventListeners();
            this.$el.html('');
            BaseView.prototype.destroy.call(this, false);
        },

        onAdResponse: function(body) {
            if(!body) {
                AdLogger.logInfo('No consumer overlay response');
            }
            this.$el.html('');
            var creativeDefJsEndIndex = body.indexOf('creative_def.js\''),
                creativeDefJsStartIndex = body.lastIndexOf('\'', creativeDefJsEndIndex);
            if (creativeDefJsEndIndex > creativeDefJsStartIndex && creativeDefJsStartIndex > -1) {
                var creativeDefJsUrl = 'https://s0.2mdn.net' + body.substring(creativeDefJsStartIndex + 1, creativeDefJsEndIndex + 15),
                    impressionPathIndex = body.indexOf("impressionUrl: '") + 16;
                this.creativeHtml = body;

                this.viewImpression = body.slice(impressionPathIndex, body.indexOf("'", impressionPathIndex));

                $.ajax({
                    type: 'GET',
                    url: creativeDefJsUrl
                }).done(this._onCreativeBody).fail(function() {
                    AdLogger.logError('Failed to get overlay ad creative def JS response');
                });
            }
        },

        _hijackRequest: function() {
            var xhrProto = XMLHttpRequest.prototype,
                send = xhrProto.send,
                open = xhrProto.open,
                securePubAds = 'securepubads.g.doubleclick.net/gampad/ads',
                that = this;

            xhrProto.open = function newOpen() {
                var url = arguments[1];
                if (url.indexOf(securePubAds) > -1) {
                    try {
                        arguments[1] = this.gntUrl = url;
                    } catch (e) {
                        // console.error('failed to hijack', e);
                    }
                }
                open.apply(this, arguments);
            };

            xhrProto.send = function newSend() {
              var o = this;
              if (o.gntUrl && o.gntUrl.indexOf(securePubAds) > -1) {
                var oldORSC = o.onreadystatechange;
                o.onreadystatechange = function newORSC() {
                  var readyState = o.readyState;
                  if (o.status < 300 && readyState === 4) {
                    try {
                        var response = o.responseText,
                            csoIdx = response && response.indexOf('/consumer_sales-overlay');
                        if(csoIdx !== -1) {
                            var matches = response.match(/\/consumer_sales-overlay.*?}\n(.*?)\n/) || [],
                                overlay = matches[1];
                            if (overlay) {
                                // Reset methods
                                xhrProto.open = open;
                                xhrProto.send = send;
                                that.onAdResponse(overlay);
                            }
                        }
                    } catch (err) {
                        console.error('error in GPT response trap: ', err);
                    }
                  }
                  oldORSC.apply(o, arguments);
                };
              }
              send.apply(o, arguments);
            };
        },

        _onCreativeBody: function(body) {
            var servingPathEndIndex = body.indexOf(".html'"),
                servingPathStartIndex = body.lastIndexOf("'", servingPathEndIndex);
            if (servingPathEndIndex > servingPathStartIndex && servingPathStartIndex > -1) {
                var servingPath = body.substring(servingPathStartIndex + 1, servingPathEndIndex + 5);
                if (servingPath.indexOf('exit.html')) {
                    // we have an exit overlay, we'll wait to attach event listeners
                    setTimeout(this._onExitOverlay, 8000);
                } else {
                    // we have an entrance overlay
                    this.viewImpression = '';
                    this._showOverlay();
                }
            }
        },

        _onExitOverlay: function() {
            $(document).on('mouseleave', this._delayExitOverlay);
            $('.site-header').on('mouseover', this._showOverlay);
            AdLogger.logInfo('Setting up CM overlay listeners for exit intent');
        },

        _delayExitOverlay: function(e) {
            if (this.eoTO) {
                clearTimeout(this.eoTO);
            }
            
            if (e.pageY < 100) {
                this._showOverlay();
            } else {
                // Delay display if they mouseout somewhere that is not the top
                this.eoTO = setTimeout(this._showOverlay, 5000);
            }
        },

        _showOverlay: function() {
            var overlay = $('<div class="partner-overlay"><div class="ui-film show"></div><div class="cm-frame-container"><iframe class="cm-overlay-frame" name="' + _.uniqueId('cm-overlay-') + '" sandbox="allow-forms allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation"></iframe><a class="close" href="#"></a></div></div>'),
                iframe = overlay.find('iframe'),
                close = overlay.find('.close');

            this.$el.append(overlay);
            $('html').addClass('lock-scroll');

            overlay.on('click', this._closeOverlay);
            close.on('click', this._closeOverlay);

            // Write creative to window
            var iframeWin = iframe[0].contentWindow;
            iframeWin.document.open();
            iframeWin.document.write(this.creativeHtml.replace(/\\n/g, '\n') + '<style>body,html{margin:0;padding:0}</style>');
            iframeWin.document.close();

            window.addEventListener('message', this._popupListener, false);

            iframe.on('load', function() {
                overlay.show();
            });

            // Fire View impression
            if(this.viewImpression) {
                (new Image()).src = this.viewImpression;
            }

            this._removeEventListeners();
            AdLogger.logInfo('Showing Consumer Marketing Overlay');
            // this.subviews.breakingbar.addToBarrier(new $.Deferred(), 999999, false);
        },

        _closeOverlay: function() {
            this.$el.html('');
            $('html').removeClass('lock-scroll');
        },

        _removeEventListeners: function() {
            $(document).off('mouseleave', this._delayExitOverlay);
            $('.site-header').off('mouseover', this._showOverlay);
        }

    });
    return MarketingOverlay;
});

